<template>
  <div class="accounts-container">
      <template>
        <el-table
          :data="list"
          style="width: 100%"
          header-row-class-name="success-row"
          height="350">
          <el-table-column
            label="课程名称"
            >
            <template slot-scope="scope">
              <span class="table_title">{{scope.row.ke_title}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="update_time"
            label="最近学习时间"
            width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="note_num"
            width="100"
            label="笔记">
            
          </el-table-column>
          <el-table-column
            align="center"
            prop="play_num"
            label="累计点播"
            width="100"
            
            >
          </el-table-column>
          <el-table-column
            align="center"
            prop="master"
            label="掌握度"
            width="100"
            >
          </el-table-column>
          <el-table-column
            label="再次学习"
            width="100"
            >
            <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="onPlay(scope.row)">点击播放</el-button>
          </template>
          </el-table-column>
        </el-table>
        <div class="clearfix list-page">
          <!-- <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.pageSize"
            :total="pageTotal"
            @current-change="handlePageChange"
          >
          </el-pagination> -->
          <el-pagination
          layout="prev, pager, next"
          :current-page="query.page"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
        >
        </el-pagination>
        </div>
      </template>
  </div>
</template>

<script>
import "@/assets/css/table.css";
export default {
  name: "courseHistory",
  data() {
    return {
      query:{
        page:1,
        pageSize: 10
      },
      list:[],
      userMoney: {},
      pageTotal: 0,
    }
  },
  created() {
    console.log(111)
    this.getList();
  },
  methods: {
    getList(){
        this.getRequest("/wenjiaoopne/kc/user/getUserCourseHistoryList",this.query)
        .then((result) => {
          this.list = result.data.list;
          this.pageTotal = result.data.total_count;
        })
        .catch(() => {});
    },
     handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getList();
    },
    onPlay(item){
      this.$router.push({ path: `/video/${item.video_id}` });
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
}
</script>
<style scoped>
.accounts-container{
  padding: 20px 30px;
}
.accounts-container .coin-img{
  width: 56px;
  height: 87px;
}
.account-head-l{
  width: 35%;
  height: 90px;
  border-right: 1px dashed #ccc;
}
.account-head-l .coin-text{
  padding-left: 15px;
}
.success-row {
    background: #f08408;
  }
.account-head-l .coin-num{
  padding-top: 5px;
  font-size:30px;
}
.account-head-r{
  width: 60%;
}

.account-head-r .milestone{
  position: relative;
  width: 225px;
  border-top: 1px dashed #ccc;
}
.milestone-item{
  position: absolute;
  top: -12px;
  left: 58px;
  padding: 0 5px;
  background-color: #fff;
}
.milestone-list .m-item-img{
  width: 100%;
  height: 100%;
  opacity: .3;
}

.milestone-list .img_opacity{
  opacity: 1!important;
}
.milestone-list{
  padding: 30px 0;
}
.milestone-list .m-item{
  width: 78px;
  height: 78px;
  border-radius: 50%;
  margin: 0 4px;

}
.account-title{
  padding: 10px 0;
  font-size:18px;
}
.accounts-container .type_1{
  color: #bc4654;
}
.accounts-container .type_2{
  color: #5C954B;
}
.header_th{
  background-color: #3ebee9!important
}
.list-page{
  padding-top: 20px;
  text-align: center;
}

</style>

